(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[616],{

/***/ 87612:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signup",
      function () {
        return __webpack_require__(2133);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 84767:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/sign-up.cda89e9c.svg","height":610,"width":648});

/***/ }),

/***/ 15670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _src_contexts_AuthContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66817);


var useAuth = function() {
    var authContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_src_contexts_AuthContext__WEBPACK_IMPORTED_MODULE_1__/* .AuthContext */ .Vo);
    return authContext;
};
/* harmony default export */ __webpack_exports__["Z"] = (useAuth);


/***/ }),

/***/ 2133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ signup_page; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
// EXTERNAL MODULE: ./src/layouts/Auth/index.tsx + 4 modules
var Auth = __webpack_require__(34328);
// EXTERNAL MODULE: ./src/templates/Auth/index.tsx + 1 modules
var templates_Auth = __webpack_require__(55571);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
// EXTERNAL MODULE: ../../node_modules/react-use/esm/useDebounce.js
var useDebounce = __webpack_require__(63611);
// EXTERNAL MODULE: ./src/components/organisms/PasswordWithRulesCard/index.ts + 1 modules
var PasswordWithRulesCard = __webpack_require__(54301);
// EXTERNAL MODULE: ./src/components/atoms/Button/index.ts + 2 modules
var Button = __webpack_require__(56042);
// EXTERNAL MODULE: ./src/components/atoms/FormErrorMessage/index.ts + 2 modules
var FormErrorMessage = __webpack_require__(4969);
// EXTERNAL MODULE: ./src/components/atoms/TextField/index.ts + 3 modules
var TextField = __webpack_require__(46903);
// EXTERNAL MODULE: ./src/components/forms/AuthForm/index.ts
var AuthForm = __webpack_require__(85787);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx
var useAuth = __webpack_require__(15670);
// EXTERNAL MODULE: ./src/utils/validations/index.ts + 1 modules
var validations = __webpack_require__(73954);
;// CONCATENATED MODULE: ./src/components/forms/SignUpForm/SignUpForm.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}












var TWO_SECONDS = 2000;
var NO_ERROR_MESSAGE = "";
var DEFAULT_REQUEST_ERROR_MESSAGE = "Something went wrong. Try again.";
var signUpFormValidate = function(formData) {
    return {
        firstName: (0,validations/* validateRequiredFields */.MN)(formData.firstName),
        lastName: (0,validations/* validateRequiredFields */.MN)(formData.lastName),
        schoolName: (0,validations/* validateRequiredFields */.MN)(formData.schoolName),
        email: (0,validations/* validateEmail */.oH)(formData.email),
        password: (0,validations/* validatePassword */.uo)(formData.password),
        confirmPassword: (0,validations/* validateConfirmPassword */.S$)(formData.password, formData.confirmPassword)
    };
};
var initialState = {
    email: "",
    firstName: "",
    lastName: "",
    schoolName: "",
    password: "",
    confirmPassword: ""
};
var SignUpForm = function() {
    var ref19, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var ref12 = (0,useAuth/* default */.Z)(), logIn = ref12.logIn, signUp = ref12.signUp;
    var ref13 = (0,react.useState)(initialState), formData = ref13[0], setFormData = ref13[1];
    var ref14 = (0,react.useState)(NO_ERROR_MESSAGE), formErrorMessage = ref14[0], setFormErrorMessage = ref14[1];
    var ref15 = (0,react.useState)({}), validatedFields = ref15[0], setValidatedFields = ref15[1];
    var isFormValid = !(0,validations/* validationHasError */.wh)(validatedFields);
    var handleValidateFields = function() {
        var validation = signUpFormValidate(formData);
        setValidatedFields(validation);
    };
    var handleInputChange = function(value, field) {
        setFormData(function(previousValues) {
            return _objectSpread({}, previousValues, _defineProperty({}, field, value));
        });
    };
    var handleSubmit = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(event) {
            var confirmPassword, signUpFormData, ref, ref16, ref17, ref18, errorMessage, errorStatusCode;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        event.preventDefault();
                        setFormErrorMessage(NO_ERROR_MESSAGE);
                        if (isFormValid) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        _ctx.prev = 4;
                        confirmPassword = formData.confirmPassword, signUpFormData = _objectWithoutProperties(formData, [
                            "confirmPassword"
                        ]);
                        _ctx.next = 8;
                        return signUp(signUpFormData);
                    case 8:
                        _ctx.next = 10;
                        return logIn({
                            email: formData.email,
                            password: formData.password
                        });
                    case 10:
                        _ctx.next = 18;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](4);
                        ;
                        errorMessage = _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : (ref16 = ref.data) === null || ref16 === void 0 ? void 0 : ref16.message;
                        errorStatusCode = _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref17 = _ctx.t0.response) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.data) === null || ref18 === void 0 ? void 0 : ref18.statusCode;
                        if (errorStatusCode === 400 && errorMessage) {
                            setFormErrorMessage(errorMessage);
                        } else {
                            setFormErrorMessage(DEFAULT_REQUEST_ERROR_MESSAGE);
                        }
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    12
                ]
            ]);
        }));
        return function handleSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,useDebounce/* default */.Z)(handleValidateFields, TWO_SECONDS, [
        formData
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(AuthForm/* AuthFormWrapper */.fS, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(AuthForm/* AuthFormTitle */.Qd, {
                children: "Sign Up"
            }),
            formErrorMessage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(FormErrorMessage/* default */.Z, {
                message: formErrorMessage
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(AuthForm/* AuthForm */.Bt, {
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(AuthForm/* AuthFromSection */.y6, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(TextField/* default */.Z, {
                                label: "Email",
                                name: "email",
                                type: "email",
                                inputMode: "email",
                                error: validatedFields === null || validatedFields === void 0 ? void 0 : (ref19 = validatedFields.email) === null || ref19 === void 0 ? void 0 : ref19.error,
                                isValid: validatedFields === null || validatedFields === void 0 ? void 0 : (ref1 = validatedFields.email) === null || ref1 === void 0 ? void 0 : ref1.isValid,
                                onChange: handleInputChange,
                                onBlur: handleValidateFields,
                                required: true
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(TextField/* default */.Z, {
                                label: "First Name",
                                name: "firstName",
                                error: validatedFields === null || validatedFields === void 0 ? void 0 : (ref2 = validatedFields.firstName) === null || ref2 === void 0 ? void 0 : ref2.error,
                                isValid: validatedFields === null || validatedFields === void 0 ? void 0 : (ref3 = validatedFields.firstName) === null || ref3 === void 0 ? void 0 : ref3.isValid,
                                onChange: handleInputChange,
                                onBlur: handleValidateFields,
                                required: true
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(TextField/* default */.Z, {
                                label: "Last Name",
                                name: "lastName",
                                error: validatedFields === null || validatedFields === void 0 ? void 0 : (ref4 = validatedFields.lastName) === null || ref4 === void 0 ? void 0 : ref4.error,
                                isValid: validatedFields === null || validatedFields === void 0 ? void 0 : (ref5 = validatedFields.lastName) === null || ref5 === void 0 ? void 0 : ref5.isValid,
                                onChange: handleInputChange,
                                onBlur: handleValidateFields,
                                required: true
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(TextField/* default */.Z, {
                                label: "School Name",
                                name: "schoolName",
                                error: validatedFields === null || validatedFields === void 0 ? void 0 : (ref6 = validatedFields.schoolName) === null || ref6 === void 0 ? void 0 : ref6.error,
                                isValid: validatedFields === null || validatedFields === void 0 ? void 0 : (ref7 = validatedFields.schoolName) === null || ref7 === void 0 ? void 0 : ref7.isValid,
                                onChange: handleInputChange,
                                onBlur: handleValidateFields,
                                required: true
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(PasswordWithRulesCard/* default */.Z, {
                                error: validatedFields === null || validatedFields === void 0 ? void 0 : (ref8 = validatedFields.password) === null || ref8 === void 0 ? void 0 : ref8.error,
                                isValid: validatedFields === null || validatedFields === void 0 ? void 0 : (ref9 = validatedFields.password) === null || ref9 === void 0 ? void 0 : ref9.isValid,
                                onChange: handleInputChange,
                                onBlur: handleValidateFields,
                                password: formData.password
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(TextField/* default */.Z, {
                                label: "Confirm Password",
                                name: "confirmPassword",
                                type: "password",
                                error: validatedFields === null || validatedFields === void 0 ? void 0 : (ref10 = validatedFields.confirmPassword) === null || ref10 === void 0 ? void 0 : ref10.error,
                                isValid: validatedFields === null || validatedFields === void 0 ? void 0 : (ref11 = validatedFields.confirmPassword) === null || ref11 === void 0 ? void 0 : ref11.isValid,
                                onChange: handleInputChange,
                                onBlur: handleValidateFields,
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(AuthForm/* AuthFromSection */.y6, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button/* default */.Z, {
                                type: "submit",
                                disabled: !isFormValid,
                                fullWidth: true,
                                children: "Sign Up"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(AuthForm/* FooterOptionText */.GB, {
                                children: [
                                    "Already have an account?",
                                    " ",
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(next_link["default"], {
                                        href: "/signin",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("a", {
                                            children: "Sign in instead."
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SignUpForm_SignUpForm = (SignUpForm);

;// CONCATENATED MODULE: ./src/components/forms/SignUpForm/index.ts


// EXTERNAL MODULE: ./public/img/illustrations/sign-up.svg
var sign_up = __webpack_require__(84767);
;// CONCATENATED MODULE: ./src/templates/SignUp/index.tsx





var SignUpTemplate = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(templates_Auth/* default */.Z, {
        illustrationSrc: sign_up/* default */.Z,
        illustrationAlt: "Two students looking at a computer screen with a form inside.",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SignUpForm_SignUpForm, {})
    });
};
/* harmony default export */ var SignUp = (SignUpTemplate);

;// CONCATENATED MODULE: ./src/pages/signup.page.tsx





var SignUpPage = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(head["default"], {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("title", {
                    children: "Sign Up - Riiid for Classrooms"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SignUp, {})
        ]
    });
};
SignUpPage.layout = Auth/* default */.Z;
/* harmony default export */ var signup_page = (SignUpPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [237,821,774,888,179], function() { return __webpack_exec__(87612); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);